<template>
  <div class="courseVue">
    <div style="margin-top: 19px">
      <div class="bg_box">
        <div class="search_type_list">
          <span class="search_type_item newWidth">班级标签 ：</span>
          <div class="search_type_newlist">
            <span :class="ClassName" @click="clickAll">全部</span>
            <span
              :class="
                k == clickNum ? 'search_type_item active' : 'search_type_item'
              "
              v-for="(i, k) in tags"
              :key="k"
              @click="Click(k, i.id)"
              >{{ i.name }}</span
            >
          </div>
        </div>
        <div class="courseSearch">
          <el-input
            placeholder="请输入内容"
            v-model="inputValue"
            clearable
            @clear="searchValue"
            class="input-with-select"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchValue"
            ></el-button>
          </el-input>
        </div>
      </div>

      <div
        class="ov_course_content"
        style="text-align: center"
        v-if="classes.length < 1"
      >
        <el-empty description="无数据"></el-empty>
      </div>
      <div class="ov_course_content">
        <div class="grade_wrapper w" visible="true">
          <div class="web_course_list">
            <video-card
              v-for="(item, index) in classes"
              :key="index"
              :item="item"
              :toPath="toPath"
            ></video-card>
          </div>
        </div>
      </div>
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-sizes="[12, 16, 20, 24]"
          :page-size="pageSize"
          :layout="layout"
          :total="totalNum"
          background
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getVideoCate, getVideoList } from "../../api/moudles/home.js";
import videoCard from "@/components/videoCard.vue";
export default {
  data() {
    return {
      columnCode: "",
      inputValue: "",
      totalNum: 0,
      ClassName: "active search_type_item",
      clickNum: null,
      tag: "",
      tags: [],
      classes: [],
      pageNo: 1,
      pageSize: 12,
      layout: "total, sizes, prev, pager, next, jumper",
      toPath: "videoplay",
    };
  },
  components: {
    videoCard,
  },
  created() {
    const pageNo = localStorage.getItem("pageNo");
    const videoPlay = localStorage.getItem("videoPlay");
    if (pageNo && videoPlay == "true") {
      this.pageNo = parseInt(pageNo);
      localStorage.setItem("videoPlay", "false");
    } else {
      this.pageNo = 1;
    }
    if (this.$route.query && this.$route.query.columnCode) {
      this.columnCode = this.$route.query.columnCode;
      if (this.$route.query.name) {
        const chooseLand = this.$route.query;
        this.getVideoCate();
        this.clickNum = chooseLand.index;
        this.ClassName = "search_type_item";
        this.tag = chooseLand.id;
        this.getVideoList(chooseLand.id);
      } else {
        this.getVideoCate(this.getVideoList);
      }
    } else if (this.$route.params && this.$route.params.name) {
      const chooseLand = this.$route.params;
      this.getVideoCate();
      this.clickNum = chooseLand.index;
      this.ClassName = "search_type_item";
      this.tag = chooseLand.id;
      this.getVideoList(chooseLand.id);
    } else {
      this.getVideoCate(this.getVideoList);
    }
  },
  watch: {
    $route: function (newValue) {
      if (newValue.query.name) {
        const chooseLand = newValue.query;
        this.clickNum = chooseLand.index;
        this.ClassName = "search_type_item";
        this.tag = chooseLand.id;
        this.getVideoList(chooseLand.id);
      }
    },
  },
  mounted() {
    if (this.$phoneSize()) {
      this.toPath = "phoneVideoplay";
      this.layout = "prev, pager, next";
    } else {
      this.toPath = "videoplay";
      this.layout = "total, sizes, prev, pager, next, jumper";
    }
  },
  methods: {
    searchValue() {
      this.pageNo = 1;
      this.getVideoList(this.tag);
    },
    // 获取视频列表
    async getVideoList(cate) {
      await getVideoList({
        data: {
          columnCode: this.columnCode,
          cate,
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          title: this.inputValue,
          userId: this.$store.state.user.userInfo.memberCode ?? "",
        },
        success: (res) => {
          //   console.log('视频list', res)
          const newList = res.data.list;
          this.classes = newList;
          this.totalNum = parseInt(res.data.total);
        },
        error: (err) => {
          console.log("视频列表失败", err);
        },
      });
    },
    // 获取视频分类
    async getVideoCate(func) {
      await getVideoCate({
        success: (res) => {
          // console.log('视频分类', res)
          this.tags = res.data;
          if (func) {
            func(undefined, null);
          }
        },
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getVideoList(this.tag);
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      localStorage.setItem("pageNo", val);
      this.getVideoList(this.tag);
    },
    Click(k, id) {
      this.clickNum = k;
      this.tag = id;
      this.pageNo = 1;
      this.ClassName = "search_type_item";
      this.getVideoList(id);
    },
    clickAll() {
      this.tag = null;
      this.pageNo = 1;
      this.clickNum = null;
      this.ClassName = "search_type_item active";
      this.getVideoList(null);
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .bg_box {
    width: 100%;
    background-color: #fff;
    border-radius: 5px;
    padding: 5px 0px;
    margin-top: 10px;

    display: flex;
    flex-flow: column;
  }
  .courseSearch {
    padding: 10px;
  }

  .courseVue {
    width: 100%;
  }

  .block {
    text-align: center;
    margin-bottom: 100px;
  }

  .w {
    width: 100%;
    box-sizing: border-box;
  }

  .web_course_list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 5px;
    grid-row-gap: 5px;
  }

  .newWidth {
    min-width: 75px;
    margin-right: 0px !important;
  }
}

@media screen and (min-width: 750px) {
  .bg_box {
    width: 100%;
    background-color: #fff;
    border-radius: 5px;
    padding: 5px 0px;
    margin-top: 10px;

    display: flex;
    justify-content: space-between;
  }
  .courseVue {
    min-height: 910px;
    width: 1200px;
    margin: 0 auto;
  }

  .block {
    text-align: center;
    margin-bottom: 20px;
  }

  .w {
    width: 1200px;
    margin: auto;
  }

  .web_course_list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 20px;
  }
}

.search_type_newlist {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.search_type_list {
  display: flex;
  /* align-items: center; */
}

.search_type_list .search_type_item {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  margin-right: 10px;
  padding: 10px;
}

.search_type_list .search_type_item.active {
  color: #2256f6;
  font-weight: 700;
  background: rgba(34, 86, 246, 0.05);
  border-radius: 5px;
}

.ov_course_content {
  margin-top: 20px;
  margin-bottom: 20px;
}

.grade_wrapper {
  padding: 5px 0;
}

.grade_main {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
  margin-right: -10px;
}

.grade_item_wrapper {
  margin-bottom: 20px;
  padding: 0 10px;
  width: 48.35%;
}

a {
  color: -webkit-link;
  cursor: pointer;
  text-decoration: none;
}

.grade_item {
  padding: 15px;
  display: flex;
  background: #ffffff;
  border-radius: 5px;
}

.item_image_wrapper {
  overflow: hidden;
  height: 128px;
  width: 230px;
  border-radius: 6px;
}

.item_image_wrapper .item_image {
  height: 100%;
  width: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

img,
video {
  max-width: 100%;
  height: auto;
}

img,
canvas,
iframe,
video {
  display: block;
  vertical-align: middle;
}

/*img {
  border-style: solid;
}*/

.grade_info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  padding-left: 10px;
}

.grade_name {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  height: 48px;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.grade_teacher {
  white-space: nowrap;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: center;
}

.grade_teacher {
  flex: 1;
  font-size: 12px;
  line-height: 18px;
  height: 42px;
  color: #999;
}

.teacher_warp_item {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  margin-right: 10px;
}

.cover_teacher {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  cursor: pointer;
}

img,
video {
  max-width: 100%;
  height: auto;
}

img,
canvas,
iframe,
video {
  display: block;
  vertical-align: middle;
}

/*
img {
  border-style: solid;
}
*/

.teacher_warp_item .teacher_name {
  margin-top: 2px;
  font-size: 12px;
  line-height: 20px;
  width: 48px;
  text-align: center;
}

.tx-ov {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.grade_info_desc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  white-space: nowrap;
  color: #999;
  line-height: 18px;
}

.price {
  line-height: 18px;
}

.price .current_price.free {
  color: #58b85c;
}

.price .current_price {
  font-size: 16px;
  font-weight: 550;
  color: #f61818;
}

.price .old_price {
  margin-left: 5px;
  font-size: 12px;
  line-height: 18px;
  color: #999;
  -webkit-text-decoration-line: line-through;
  text-decoration-line: line-through;
}

.grade_teacher {
  white-space: nowrap;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: center;
}

.grade_teacher {
  flex: 1;
  font-size: 12px;
  line-height: 18px;
  height: 42px;
  color: #999;
}

/**滚动条的宽度*/
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/*滚动条的滑块*/
::-webkit-scrollbar-thumb {
  background-color: rgb(185, 221, 255);
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(24, 144, 255, 0.8);
}

/**
  精品课程
   */

.normalFlex {
  display: flex;
  align-items: center;
}

.courseFlex {
  height: 50px;
  justify-content: space-between;
  padding-right: 12px;
  margin-bottom: 30px;
}

.view_father3 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 20px;
  margin: 30px 0;
}

.courseFlex_right {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #d40d16;
  letter-spacing: 0;
  text-align: center;
  line-height: 18px;
  font-weight: 400;
}

.courseFlex_right:hover {
  cursor: pointer;
  text-decoration: underline;
}

.course_box {
  cursor: pointer;
  width: 280px;
  height: 80px;
  background-image: linear-gradient(to right, #f2f8fe 100%, #ffffff 100%);
  border-radius: 1.33px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 20px;
  border: 1px solid rgba(242, 244, 246, 1);
}

.course_box img {
  width: 44px;
  height: 44px;
}

.course_box p {
  font-size: 18px;
  letter-spacing: 0;
  text-align: center;
  font-weight: 600;
  font-family: PingFangSC-Medium;
  color: rgba(0, 0, 0, 0.85);
}

.zjxheader {
  height: 100px;
  width: 100%;
  background-color: #c01219;
}

.zjxheader_center {
  width: 1200px;
  margin: 0 auto;
  height: 100px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.zjxheader_center__left {
}

.zjxheader_center__left_p {
  height: 50px;
  line-height: 50px;
  text-align: right;
  color: #fff;

  font-family: PingFangSC-Regular;
  font-size: 14px;
  letter-spacing: 0;
  font-weight: 400;
}

.zjxWarpList {
  width: 600px;
  height: 380px;
}

.zjxRightView {
  width: 590px;
  display: flex;
  justify-content: space-between;
}

.zjxRightView_left {
  background-color: #fff;
  width: 394px;
}

.zjxRightView_Right {
  width: 186px;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
}

.zjxRightView_Right__view {
  height: 80px;
  width: 186px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.zjxRightView_Right__view p {
  margin-left: 14px;
}

.zjxRightView_Right__view:nth-child(odd) {
  background-color: #d40d16;
}

.zjxRightView_Right__view:nth-child(even) {
  background-color: #c19b61;
}

.zjx_course_span {
  display: inline-block;
  width: 5px;
  height: 24px;
  background: #0182fd;
}

.zjx_course_p {
  margin-left: 15px;
  font-size: 24px;
  letter-spacing: 0;
  font-weight: 600;
  font-family: PangMenZhengDao;
  color: #131415;
}

.grestProgrma {
  display: flex;
  justify-content: space-between;
}

.grestProgrma_view {
  display: flex;
  flex-flow: column;
  align-items: center;
  border: 1px solid rgba(219, 219, 219, 1);
  cursor: pointer;
  position: relative;
}

.grestProgrma_view img {
  width: 294px;
  height: 246px;
}

.grestProgrma_view p {
  display: inline-block;
  margin: 10px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 270px;
}
</style>
